import { render, staticRenderFns } from "./OrderPatientForm.vue?vue&type=template&id=c1a45272&scoped=true&"
import script from "./OrderPatientForm.vue?vue&type=script&lang=js&"
export * from "./OrderPatientForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderPatientForm.vue?vue&type=style&index=0&id=c1a45272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a45272",
  null
  
)

export default component.exports